import { render } from "./TgTour.vue?vue&type=template&id=4400b912"
import script from "./TgTour.vue?vue&type=script&lang=js"
export * from "./TgTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__